// assets
import logo from 'assets/images/logo.png';

// ==============================|| LOGO - NEXTGEN GTN ||============================== //

export default function LogoMain() {
  return <img src={logo} alt="NextGen GTN™ — Patients + Profitability™" style={{ height: 40, width: 'auto', display: 'block' }} />;
}
